import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../core/abstraction/auth.service';
import { ISuccessLogin } from '../models/Auth';
import { AuthenticationService } from './authentication.service';
import { CrossLoginSocketService } from './cross-login-socket.service';

@Injectable({
  providedIn: 'root',
})
export class CrossLoginService {
  constructor(
    private crossLoginSocketService: CrossLoginSocketService,
    private authService: AuthenticationService,
    private userService: AuthService,
  ) {}

  initializeSigninQr(token: string): Observable<ISuccessLogin> {
    return new Observable((observer) => {
      this.crossLoginSocketService.connect(token);

      this.crossLoginSocketService.socket.on('crossLogin', (resp: ISuccessLogin) => {
        let complianceChecks = resp.complianceChecks;
        if (Object.values(complianceChecks).some((item) => item === true)) {
          this.userService.complianceChecks = complianceChecks;
          this.authService.requestComplianceExpiredData();
        }
        const user = resp.user;
        this.authService.setLoggedUserData(resp);

        if (user) {
          observer.next(resp);
        }
      });

      this.crossLoginSocketService.socket.on('disconnect', () => {
        observer.complete();
      });

      this.crossLoginSocketService.socket.on('error', (e) => {
        observer.error(e);
      });

      this.crossLoginSocketService.socket.on('connect_error', (e) => {
        observer.error(e);
      });
    });
  }

  disconnectQRSocket() {
    this.crossLoginSocketService.socket.disconnect();
  }
}
